import { useEffect, useRef } from 'react'

import type { UseStickyToolbarProps } from './useStickyToolbar.types'

export function useStickyToolbar({
  enabled,
  editor,
  editorRef,
  cssLoading,
}: UseStickyToolbarProps) {
  const originalLimiterElementRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (!editorRef.current || !editor) {
      return
    }

    const modal = editorRef.current.closest('[data-id="modal"]')
    if (!modal) {
      return
    }

    const modalHeader = modal.querySelector('[data-id="modal-header"]')
    if (!modalHeader) {
      return
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = getComputedStyle(entry.target)
        const heightValue = parseInt(height, 10) - 1
        modal.setAttribute('style', `--modal-header-height: ${heightValue}px`)
      }
    })

    resizeObserver.observe(modalHeader)
    return () => resizeObserver.disconnect()
  }, [editorRef, editor])

  useEffect(() => {
    if (!editorRef.current || cssLoading || !editor?.ui.view.stickyPanel) {
      return
    }

    const stickyPanel = editor.ui.view.stickyPanel

    if (!enabled) {
      originalLimiterElementRef.current = stickyPanel.limiterElement
      stickyPanel.limiterElement = null
    } else if (originalLimiterElementRef.current) {
      stickyPanel.limiterElement = originalLimiterElementRef.current
      originalLimiterElementRef.current = null
    }
  }, [enabled, editorRef, editor, cssLoading])
}
